import { useCallback } from 'react';
import { refreshUserLocation } from 'src/common/location/refreshUserLocation';
import { useWfUserStore } from '../stores/WfUserStore';
import useWfUserService from './WfUserService';

export function useWfLocationService() {
  const { user } = useWfUserStore();
  const { wfUpdateUserLocation } = useWfUserService();

  const updateWfUserLocation = useCallback(async () => {
    const latitude = user?.location?.latitude ?? null;
    const longitude = user?.location?.longitude ?? null;

    const result = await refreshUserLocation(latitude, longitude);

    if (result.latitude != null && result.longitude != null) {
      wfUpdateUserLocation(result.latitude, result.longitude);
    }
  }, [user?.location?.latitude, user?.location?.longitude, wfUpdateUserLocation]);

  return { updateWfUserLocation };
}
